import { useQuery } from "react-query";
import { getInspectors } from "../../../queries/employees";
import { useSelector } from "react-redux";
import network from "../../../selectors/network";

interface IUseInspectors {
  inspectionTypeId: number;
}
export default function useInspectors({ inspectionTypeId }: IUseInspectors) {
  const networkHeaders = useSelector(network.defaultHeaders);
  const query = useQuery<GetInspectorsResBody>(
    ["inspectors", inspectionTypeId],
    getInspectors(networkHeaders, inspectionTypeId?.toString()),
    {
      enabled: !!inspectionTypeId,
    },
  );
  return query;
}

interface GetInspectorsResBody {
  data: Inspector[];
}

// Type for payload we get back from the employees service - there are other fields present, I'm just uncertain of the types for them :/
interface Inspector {
  id: string;
  type: "employee";
  attributes: {
    "first-name": string | null;
    "last-name": string | null;
    "inspector": true;
  };
}
